import { config } from '../config';
import axios from 'axios';

export function getMemberPreferences() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/member-preferences`,
  };
}

export function updateMemberDetails({ userId, changedInfo }) {
  return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/api/members/${userId}`,
    data: {
      id: userId,
      ...changedInfo,
    },
  };
}
export function patchMemberDetails({ user, userId, changedInfo }) {
  const { accessToken } = user;
  const headers = {
    'Content-Type': 'application/json-patch+json',
    Authorization: `Bearer ${accessToken}`,
  };
  return axios.patch(
    `${config.core.membershipServiceUrl}/v1.0/members/${userId}`,
    changedInfo,
    { headers }
  );
}

export function getMemberExists({ name }) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/members/display-name-exists/${name}`,
  };
}

//Support Tools & Admin Portal
//------------------------------------------------------------
export function searchMember(searchTerm) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/members/search/${searchTerm}`,
  };
}

export function fetchMemberById(id) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/members/search-by-id/${id}`,
  };
}

export function getSponsorData(memberId) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/members/${memberId}/sponsor`,
  };
}

export function updateMemberSponsor({ memberId, sponsorEmail, reason }) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/members/update-member-sponsor`,
    data: {
      memberId,
      sponsorEmail,
      reason,
    },
  };
}

export function updateAccountEmail(id, email, reason) {
  return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/api/members/${id}/change-email`,
    data: {
      id,
      email,
      reason,
    },
  };
}

export function getAllAgreements() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/agreements`,
  };
}

export function getAgreementById(id) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/agreements/${id}`,
  };
}

export function getAgreementsByUser(memberId) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/member-agreements/${memberId}`,
  };
}

export function getUserLogs(memberId) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/user-logs/${memberId}`,
  };
}

export function getPendingAgreements(memberId, contextTypeId = 1) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/member-agreements/member/${memberId}?contextTypeId=${contextTypeId}`,
  };
}

//------------------------------------------------------------

export function getMembersWithRoles() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/roles/membersRoles`,
  };
}

// --- Agreement Management
export function getCustomAgreementsList() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/custom-agreements`,
  };
}

export function getAgreementsIsUsed(id) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/custom-agreements/agreement-in-use/${id}`,
  };
}

export function updateCustomAgreement(data) {
  return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/v1.0/custom-agreements`,
    data,
  };
}

export function createCustomAgreement(data) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/v1.0/custom-agreements`,
    data,
  };
}

export function getCustomAgreementsByMember(memberId) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/custom-agreements/${memberId}`,
  };
}

export async function uploadCustomAgreement(
  customAgreement,
  memberId,
  customAgreementId,
  token
) {
  const formData = new FormData();
  formData.append('document', customAgreement);
  formData.append('createMemberCustomAgreementRequest.memberId', memberId);
  formData.append(
    'createMemberCustomAgreementRequest.customAgreementId',
    customAgreementId
  );
  const result = await axios({
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/member-custom-agreements/`,
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return result;
}

export function lockFirebaseMember(data) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/members/lock-firebase-member`,
    data,
  };
}

export function unlockFirebaseMember(data) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/members/unlock-firebase-member`,
    data,
  };
}

export function getIsMemberLocked(memberId) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/members/${memberId}/is-locked`,
  };
}

export function updateMemberRole(memberId, roleId) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/members/${memberId}/roles`,
    data: {
      memberId: memberId,
      roleIds: roleId,
    },
  };
}

// Site Admin ---------
export function getRoles() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/roles`,
  };
}

export function getRoleById(id) {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/roles/${id}`,
  };
}

export function updateRoleData(id, data) {
  return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/v1.0/roles/${id}`,
    data,
  };
}

export function updateRolePermissions(id, data) {
  return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/v1.0/roles/${id}/permissions`,
    data: {
      permissionIds: data,
    },
  };
}

export function createRole(data) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/v1.0/roles`,
    data,
  };
}

export function getPermissions() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/v1.0/permissions`,
  };
}

export function generateCoreBypassToken({ tokenType }) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/v1.0/auth-token/bypass?tokenType=${tokenType}`,
  };
}
